// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"1441":"optimiser-login","2232":"optimiser-forgot-password","3759":"optimiser-drive-share","8719":"unsubscribe"}[chunkId] + "." + {"1441":"139c2ea75fa400be528c","2232":"139c2ea75fa400be528c","3759":"e8f86579892e7fd8e315","8719":"e57391edfcf3d9aa1de8"}[chunkId] + ".css";
};